export default (trigger) => {
    if (typeof window === "object" && typeof window.hj === "function") {
        window.hj('trigger', trigger)
    }
}